
import "./App.css";
import Footer from "./components/Footer";
import TopNav from "./components/TopNav";
import MainNav from "./components/MainNav";
import SubNav from "./components/subNav";
import AppRouter from "./config/AppRouter";
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { setNavigator } from "./store/useAuthStore";
import { useEffect } from "react";
import { useCategoryStore } from "./store/useCategoryStore";
import { useProductStore } from "./store/useProductStore";
import { useLocation } from 'react-router-dom';
import './lib/axiosInterceptor.js';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return null; 
};

function InitNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return null;
}

function App() {

  const { getCategory } = useCategoryStore()
  const { getAllProduct } = useProductStore()

  useEffect(() => {
    const fetchData = async () => {
      await getCategory();
      await getAllProduct(1, 10, '', '');
    };
    fetchData();
  }, []);

  return (
    <>
      <Router base="/">
       <ScrollToTop /> 
        <InitNavigator />
        <Toaster position="top-center" />
        <TopNav />
        <SubNav />
        <MainNav />
        <AppRouter />
        <Footer />
      </Router>
    </>
  );
}

export default App;
